import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import AiOrGeneral from './AiOrGeneral'
import GeneralForm from './GeneralForm'
import PartOneAiForm from './PartOneAiForm'
import PartTwoAiForm from './PartTwoAiForm'
import { useTranslation } from '../../hooks/useTranslation'

const PracticeInterviewForm = () => {
  const {
    practice_interview_images,
    uiState,
    setUiState,
    generatePracticeInterview,
  } = usePracticeInterviewing()
  const { t } = useTranslation('PracticeInterviewForm')
  return (
    <div className="flex w-full flex-col rounded-2xl bg-lily-blue px-4 py-8 text-primary md:m-8 md:flex-row">
      <div className="md:w-1/2">
        {uiState.aiOrGeneral && <AiOrGeneral />}
        {!uiState.aiOrGeneral && !uiState.aiInterview && <GeneralForm />}
        {uiState.formIndex === 0 &&
          !uiState.aiOrGeneral &&
          uiState.aiInterview && <PartOneAiForm />}
        {uiState.formIndex === 1 &&
          !uiState.aiOrGeneral &&
          uiState.aiInterview && <PartTwoAiForm />}
      </div>
      <div className="md:w-1/2">
        {uiState.aiOrGeneral && (
          <div className="flex h-full w-full flex-col">
            <div className="m-auto h-2/3 w-2/3">
              <img src={practice_interview_images[0]} alt="" />
            </div>
            <div className="w-full text-center md:text-right">
              <Button
                onClick={() =>
                  setUiState((prev) => ({ ...prev, showForm: false }))
                }
                className="mr-8 !border-[#2F2F2F] bg-white text-[#2F2F2F] hover:!bg-accent  hover:text-[#2F2F2F] focus:border-accent focus:bg-accent focus:text-[#2F2F2F] active:border-accent active:bg-accent active:text-[#2F2F2F]"
              >
                {t('back')}
              </Button>
              <Button
                onClick={() =>
                  setUiState((prev) => ({
                    ...prev,
                    aiOrGeneral: false,
                  }))
                }
              >
                {t('continue')}
              </Button>
            </div>
          </div>
        )}
        {!uiState.aiOrGeneral && !uiState.aiInterview && (
          <div className="flex h-full w-full flex-col">
            <div className="m-auto h-2/3 w-2/3">
              <img src={practice_interview_images[0]} alt="" />
            </div>
            <div className="w-full text-center md:text-right">
              <Button
                onClick={() =>
                  setUiState((prev) => ({ ...prev, aiOrGeneral: true }))
                }
                className="mr-8 !border-[#2F2F2F] bg-white text-[#2F2F2F] hover:!bg-accent  hover:text-[#2F2F2F] focus:border-accent focus:bg-accent focus:text-[#2F2F2F] active:border-accent active:bg-accent active:text-[#2F2F2F]"
              >
                {t('back')}
              </Button>
              <Button onClick={() => generatePracticeInterview()}>
                {t('generate_interview')}
              </Button>
            </div>
          </div>
        )}
        {uiState.formIndex === 0 &&
          !uiState.aiOrGeneral &&
          uiState.aiInterview && (
            <div className="flex h-full w-full flex-col">
              <div className="m-auto h-2/3 w-2/3">
                <img src={practice_interview_images[0]} alt="" />
              </div>
              <div className="w-full text-center md:text-right">
                <Button
                  onClick={() =>
                    setUiState((prev) => ({ ...prev, aiOrGeneral: true }))
                  }
                  className="mr-8 !border-[#2F2F2F] bg-white text-[#2F2F2F] hover:!bg-accent  hover:text-[#2F2F2F] focus:border-accent focus:bg-accent focus:text-[#2F2F2F] active:border-accent active:bg-accent active:text-[#2F2F2F]"
                >
                  {t('back')}
                </Button>
                <Button
                  disabled={uiState.disableContinue}
                  onClick={() =>
                    setUiState((prev) => ({ ...prev, formIndex: 1 }))
                  }
                >
                  {t('continue')}
                </Button>
              </div>
            </div>
          )}
        {uiState.formIndex === 1 &&
          !uiState.aiOrGeneral &&
          uiState.aiInterview && (
            <div className="flex h-full w-full flex-col">
              <div className="m-auto h-1/2 w-1/2">
                <img src={practice_interview_images[1]} alt="" />
              </div>
              <div className="w-full text-right">
                <Button
                  onClick={() =>
                    setUiState((prev) => ({ ...prev, formIndex: 0 }))
                  }
                  className="mr-8 !border-[#2F2F2F] bg-white text-[#2F2F2F] hover:!bg-accent  hover:text-[#2F2F2F] focus:border-accent focus:bg-accent focus:text-[#2F2F2F] active:border-accent active:bg-accent active:text-[#2F2F2F]"
                >
                  {t('back')}
                </Button>
                <Button onClick={() => generatePracticeInterview()}>
                  {t('generate_interview')}
                </Button>
              </div>
            </div>
          )}
      </div>
    </div>
  )
}

export default PracticeInterviewForm
